<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formProdutoEstoque from '@/src/components/form-produto-estoque'

import Produto from '@/src/services/produto_estoque'
import moment from 'moment'
moment.locale('pt-br')

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formProdutoEstoque },
  data() {
    return {
      mostraForm: true,
      produtoEdit: {},
      produtos: [],
      produtosSelect: [],
      produtoFields: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'valor_venda',
          label: 'Valor Venda',
          class: 'size-col-20',
        },
        {
          key: 'custo_medio',
          label: 'Custo Médio',
          class: 'size-col-20',
        },
        {
          key: 'data_cadastro',
          label: 'Data de entrada',
          class: 'size-col-20',
        },        
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      showFilterSidebar: false,
      isLoading: false,
      idProduto: '',
      filter: '',
      filtros: {
        nome: '',
        categoria: '',
        marca: '',
        fabricante: '',
        ativo: null,
        valor_venda_min: '',
        valor_venda_max: '',
        custo_medio_min: '',
        custo_medio_max: '',
        estoque_min: '',
        estoque_max: '',
        data_cadastro_inicio: '',
        data_cadastro_fim: '',
      },
      ativoOptions: [
        { value: null, text: 'Todos' },
        { value: true, text: 'Ativo' },
        { value: false, text: 'Inativo' },
      ],
      rows: 0,
    }
  },
  computed: {
    totalFiltrosAplicados() {
      return Object.values(this.filtros).filter((value) => {
        return value !== '' && value !== null && value !== undefined
      }).length
    },
  },

  watch: {
    currentPage() {
      this.listar()
    },
  },
  mounted() {
    this.listar()
    this.produtoEdit.if_nf = false;
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      Produto.listarNotFilter(token, this.perPage, this.currentPage, this.getFiltrosParams())
        .then((resposta) => {
          this.produtos = resposta.data.produtos || []
          this.rows = resposta.data.count || 0
        })
        .catch(() => {
          this.produtos = []
          this.rows = 0
          this.$bvToast.toast('Não foi possível listar os produtos.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getFiltrosParams() {
      return Object.keys(this.filtros).reduce((params, key) => {
        const value = this.filtros[key]

        if (value !== '' && value !== null && value !== undefined) {
          params[key] = value
        }

        return params
      }, {})
    },
    aplicarFiltros() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.listar()
      }
      this.showFilterSidebar = false
    },
    limparFiltros() {
      Object.keys(this.filtros).forEach((key) => {
        this.filtros[key] = key === 'ativo' ? null : ''
      })
      this.filter = ''
      this.aplicarFiltros()
    },
    getProdutoDetalhePayload(resposta, fallback = {}) {
      const payload = resposta && resposta.data ? resposta.data : {}
      const produto =
        payload.produto ||
        (payload.dados && payload.dados.produto) ||
        (payload.data && payload.data.produto) ||
        payload.dados ||
        payload.item ||
        payload.data ||
        payload.sucesso ||
        payload

      const produtoDetalhado = Array.isArray(produto)
        ? produto.find((item) => String(item.id_produto || item.id) === String(fallback.id_produto || fallback.id)) || {}
        : produto || {}

      return {
        ...fallback,
        ...produtoDetalhado,
        id_produto: produtoDetalhado.id_produto || fallback.id_produto,
        fornecedor_principal:
          produtoDetalhado.fornecedor_principal ||
          produtoDetalhado.fornecedor_nome ||
          produtoDetalhado.fornecedor ||
          fallback.fornecedor_principal ||
          fallback.fornecedor_nome ||
          fallback.fornecedor,
      }
    },
    async editRegister(produto) {
      const token = this.$store.state.auth.currentUser.token
      const idProduto = produto.id_produto || produto.id

      if (!idProduto) {
        this.produtoEdit = { ...produto }
        this.mostraForm = false
        return
      }

      this.isLoading = true

      try {
        const resposta = await Produto.consultar(token, idProduto)
        this.produtoEdit = this.getProdutoDetalhePayload(resposta, produto)
      } catch (error) {
        this.produtoEdit = { ...produto }
        this.$bvToast.toast('Não foi possível carregar todos os dados do produto. Abrindo com os dados da listagem.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }

      this.mostraForm = false
    },
    cancelarCadastro() {
      this.mostraForm = true
      this.listar()
    },
    salvarProduto(resetAfterSave = false) {
      if (this.$refs.formProduto && this.$refs.formProduto.salvarProduto) {
        this.$refs.formProduto.salvarProduto(resetAfterSave)
      }
    },
    handleProdutoSalvo({ resetAfterSave }) {
      if (!resetAfterSave) {
        this.mostraForm = true
        this.listar()
      }
    },
    cadastra() {
      if (this.produtoEdit) {
        this.produtoEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
        this.produtoEdit.ativo = true        
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    async Deletar() {
      const token = this.$store.state.auth.currentUser.token
      const idProduto = this.idProduto
      this.isLoading = true

      try {
        await Produto.deletar(token, idProduto)
        await this.listar()
      } catch (err) {
        const mensagem =
          err.response && err.response.data && Array.isArray(err.response.data.data)
            ? err.response.data.data.join(', ')
            : 'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.'

        this.$bvToast.toast(mensagem, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }

      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row align-items-start">
          <div class="col-md-7">
            <div class="titulo">
              {{ mostraForm ? 'Produtos' : 'Cadastro de Produto' }}
            </div>
            <div class="subTitulo">
              <span v-if="mostraForm">Gerencie os produtos cadastrados no estoque.</span>
              <span v-else>
                Cadastre produtos, preços, estoque, fornecedores, dados fiscais e informações específicas para controle comercial, agrícola e pet shop.
              </span>
            </div>
          </div>
          <div class="col-md-5">
            <div class="product-page-actions">
              <button
                v-if="mostraForm"
                type="button"
                class="btn btn-light product-filter-button"
                @click="showFilterSidebar = true"
              >
                <i class="uil uil-filter"></i>
                Filtros
                <b-badge v-if="totalFiltrosAplicados" variant="primary">{{ totalFiltrosAplicados }}</b-badge>
              </button>
              <button v-if="mostraForm" class="btn btn-primary" @click="cadastra">
                <i class="uil uil-plus"></i>
                Novo Produto
              </button>
              <template v-else>
                <button class="btn btn-outline-secondary" @click="cancelarCadastro">
                  Cancelar
                </button>
                <button class="btn btn-primary" @click="salvarProduto(false)">
                  <i class="uil uil-save"></i>
                  Salvar
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div>
        <div v-if="mostraForm">
          <div class="col-md-12">
            <div class="float-right">
              <div class="description found"><b>Total de Registros: {{ this.rows }}</b> </div>
            </div>
          </div>
          
          <b-table
            striped
            hover
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="produtos"
            :fields="produtoFields"
            :per-page="perPage"
            show-empty
          >
            <template #empty="scope">
              <div class="row">
                <div class="col-md-12">
                  <span>Nenhum produto encontrado!</span>
                </div>
              </div>
            </template>
            <template v-slot:cell(data_cadastro)="row">
            {{
              formatDate(row.item.data_cadastro) !== 'Invalid date'
                ? formatDate(row.item.data_cadastro)
                : row.item.data_cadastro
            }}
          </template>
            <template v-slot:cell(actions)="row">
              <b-dropdown
                class="product-actions-menu"
                toggle-class="product-actions-toggle"
                variant="link"
                no-caret
                right
              >
                <template v-slot:button-content>
                  <i class="uil uil-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click="editRegister(row.item)">
                  <i class="uil uil-edit"></i>
                  Editar
                </b-dropdown-item>
                <b-dropdown-item @click="modalDelete(row.item.id_produto)">
                  <i class="uil uil-trash-alt"></i>
                  Excluir
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <template v-slot:cell(ativo)="row">{{
              row.item.ativo ? 'Sim' : 'Não'
            }}</template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>

        <div v-else>
          <formProdutoEstoque ref="formProduto" :produto="produtoEdit" @onSave="handleProdutoSalvo" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>
    <b-sidebar
      id="product-filter-sidebar"
      v-model="showFilterSidebar"
      title="Filtros"
      right
      shadow
      backdrop
      width="380px"
      body-class="product-filter-sidebar-body"
    >
      <b-form class="product-filter-form" @submit.prevent="aplicarFiltros">
        <b-form-group label="Nome / descrição">
          <b-form-input v-model="filtros.nome" placeholder="Buscar por produto" />
        </b-form-group>

        <b-form-group label="Categoria">
          <b-form-input v-model="filtros.categoria" placeholder="Ex.: Defensivos" />
        </b-form-group>

        <b-form-group label="Marca">
          <b-form-input v-model="filtros.marca" placeholder="Ex.: AgroMax" />
        </b-form-group>

        <b-form-group label="Fabricante">
          <b-form-input v-model="filtros.fabricante" placeholder="Buscar fabricante" />
        </b-form-group>

        <b-form-group label="Situação">
          <b-form-select v-model="filtros.ativo" :options="ativoOptions" />
        </b-form-group>

        <div class="product-filter-range">
          <b-form-group label="Valor venda mín.">
            <b-form-input v-model="filtros.valor_venda_min" type="number" step="0.01" />
          </b-form-group>
          <b-form-group label="Valor venda máx.">
            <b-form-input v-model="filtros.valor_venda_max" type="number" step="0.01" />
          </b-form-group>
        </div>

        <div class="product-filter-range">
          <b-form-group label="Custo médio mín.">
            <b-form-input v-model="filtros.custo_medio_min" type="number" step="0.01" />
          </b-form-group>
          <b-form-group label="Custo médio máx.">
            <b-form-input v-model="filtros.custo_medio_max" type="number" step="0.01" />
          </b-form-group>
        </div>

        <div class="product-filter-range">
          <b-form-group label="Estoque mín.">
            <b-form-input v-model="filtros.estoque_min" type="number" step="0.01" />
          </b-form-group>
          <b-form-group label="Estoque máx.">
            <b-form-input v-model="filtros.estoque_max" type="number" step="0.01" />
          </b-form-group>
        </div>

        <div class="product-filter-range">
          <b-form-group label="Cadastro início">
            <b-form-datepicker
              v-model="filtros.data_cadastro_inicio"
              class="product-date-field"
              locale="pt-br"
              placeholder="Selecione a data"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              reset-button
              label-reset-button="Limpar"
            >
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
          <b-form-group label="Cadastro fim">
            <b-form-datepicker
              v-model="filtros.data_cadastro_fim"
              class="product-date-field"
              locale="pt-br"
              placeholder="Selecione a data"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              reset-button
              label-reset-button="Limpar"
            >
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>

        <div class="product-filter-sidebar-actions">
          <button class="btn btn-light" type="button" @click="limparFiltros">
            Limpar filtros
          </button>
          <button class="btn btn-webreceita" type="submit">
            <i class="uil uil-search"></i>
            Aplicar filtros
          </button>
        </div>
      </b-form>
    </b-sidebar>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.product-page-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  .btn {
    min-width: 130px;
    height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    border-radius: 5px;
    font-weight: 700;
    margin: 0;
    padding: 0 18px;
  }

  .btn-primary {
    border-color: #008e75;
    background-color: #008e75;
  }

  .btn-light {
    background: #fff;
    border: 1px solid #d8dee8;
    color: #172033;
  }

  .btn-outline-primary {
    border-color: #cbd8df;
    color: #0f1f33;
    background: #fff;

    &:hover {
      border-color: #008e75;
      color: #008e75;
      background: #f2fbf8;
    }
  }

  .btn-outline-secondary {
    border-color: #cbd8df;
    color: #0f1f33;
    background: #fff;

    &:hover {
      background: #f4f7f9;
      color: #0f1f33;
    }
  }
}

.product-filter-button {
  background: #fff;
  border: 1px solid #cfd9e6;
  color: #172033;
  min-width: 116px;

  i {
    color: #008e75;
    font-size: 20px;
  }

  .badge {
    background-color: #008e75;
  }

  &:hover {
    border-color: #008e75;
    color: #008e75;
    background: #f2fbf8;
  }
}

.product-filter-sidebar-body {
  padding: 18px 20px 84px;
}

.product-filter-form {
  display: grid;
  gap: 14px;
  padding: 4px 8px 18px;

  .form-group {
    margin: 0;
  }

  label,
  legend {
    color: #172033;
    font-size: 13px;
    font-weight: 800;
  }

  .form-control,
  .custom-select {
    border: 1px solid #d8dee8;
    border-radius: 5px;
    box-shadow: none;
    color: #536074;
    font-weight: 700;
    height: 42px;
    min-height: 42px;
  }

  .form-control:focus,
  .custom-select:focus {
    border-color: #008e75;
    box-shadow: 0 0 0 3px rgba(0, 142, 117, 0.12);
  }

  .form-control::placeholder {
    color: #8a96a8;
    font-weight: 600;
  }

  .product-date-field {
    align-items: stretch;
    border: 1px solid #d8dee8;
    border-radius: 5px;
    min-height: 42px;
  }

  .product-date-field > .btn {
    align-items: center;
    background: #fff;
    border: 0;
    border-right: 1px solid #d8dee8;
    border-radius: 5px 0 0 5px;
    color: #008e75;
    display: inline-flex;
    height: 40px;
    justify-content: center;
    margin: 0;
    min-width: 42px;
    padding: 0;
  }

  .product-date-field .form-control {
    border: 0;
    border-radius: 0 5px 5px 0;
    height: 40px;
    min-height: 40px;
  }
}

.product-filter-range {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.product-filter-sidebar-actions {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  left: 0;
  padding: 14px 20px;
  right: 0;
  border-top: 1px solid #e7edf4;
  background: #fff;
  width: 100%;

  .btn {
    border-radius: 5px;
    border-width: 1px;
    height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    font-weight: 800;
    margin: 0;
    min-width: 138px;
    padding: 0 18px;
    white-space: nowrap;
  }

  .btn-light {
    background: #fff;
    border-color: #d8dee8;
    color: #172033;
  }

  .btn-webreceita {
    border-color: #008e75;
    background-color: #008e75;
    color: #fff;
    min-width: 178px;
  }
}

.product-actions-menu {
  display: inline-flex;
}

.product-actions-menu .product-actions-toggle {
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  color: #536074;
  display: inline-flex;
  font-size: 20px;
  height: 34px;
  justify-content: center;
  padding: 0;
  width: 34px;
}

.product-actions-menu .product-actions-toggle:hover,
.product-actions-menu.show .product-actions-toggle {
  background: #e4f6f0;
  border-color: #bee2dc;
  color: #008e75;
  text-decoration: none;
}

.product-actions-menu .dropdown-menu {
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
  min-width: 150px;
  padding: 6px;
}

.product-actions-menu .dropdown-item {
  align-items: center;
  border-radius: 5px;
  color: #172033;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 8px;
  padding: 8px 10px;
}

.product-actions-menu .dropdown-item i {
  color: #008e75;
  font-size: 17px;
}

@media (max-width: 768px) {
  .product-page-actions {
    justify-content: flex-start;
    margin-top: 16px;

    .btn {
      flex: 1 1 100%;
    }
  }

  .product-filter-range {
    grid-template-columns: 1fr;
  }
}
</style>
